"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validCpf = validCpf;
exports.maskCpf = maskCpf;
const normalize_1 = require("./normalize");
const RESERVED = [
    '00000000000', '11111111111', '22222222222', '33333333333', '44444444444',
    '55555555555', '66666666666', '77777777777', '88888888888', '99999999999',
];
function validCpf(value) {
    const cpf = (0, normalize_1.onlyDigits)(value);
    if (!cpf || cpf.length !== 11 || RESERVED.includes(cpf))
        return false;
    let soma = 0;
    for (let i = 1; i <= 9; i++)
        soma += parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11)
        resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10), 10))
        return false;
    soma = 0;
    for (let i = 1; i <= 10; i++)
        soma += parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11)
        resto = 0;
    return resto === parseInt(cpf.substring(10, 11), 10);
}
function maskCpf(value) {
    const v = (0, normalize_1.onlyDigits)(value).slice(0, 11);
    let out = '';
    for (let i = 0; i < v.length; i++) {
        if (i === 3 || i === 6)
            out += '.';
        else if (i === 9)
            out += '-';
        out += v[i];
    }
    return out;
}
